import { render, staticRenderFns } from "./property-link.vue?vue&type=template&id=19a9e91d"
import script from "./property-link.vue?vue&type=script&lang=js"
export * from "./property-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports